/** 文件说明
@Author: dalang
@LastModifyTime: 2022-05-08  17:41:46
@Desc: 万知商务-公共模块路由表
**/
const BusinessIndex = () => import('@/components/business/BusinessIndex')
const BusinessPage = () => import('@/components/business/pages/frontedPage/BusinessPage')
const BusinesserSettle = () => import('@/components/business/pages/BusinesserSettleIn/Index')
const BusinessEvaluation = () => import('@/components/business/pages/businessEvaluation/Index')
const BusinessRequireInfo = () => import('@/components/business/pages/BusinessInformation/Index')
const ShoppingCart = () => import('@/components/business/pages/shoppingCartModule')
const SnapUp = () => import('@/components/business/pages/snapUp/Order')

export default {
  path: '/wzmall',
  name: 'Wzmall',
  component: BusinessIndex,
  redirect: '/wzmall/businessRequireInfo',
  meta: {
    title: '万知商务',
    requireLogin: false
  },
  children: [
    {
      path: '/wzmall/businessRequireInfo',
      name: 'BusinessRequireInfo',
      component: BusinessRequireInfo,
      meta: {
        title: '万知商务-首页信息'
      }
    },
    {
      path: '/wzmall/index',
      name: 'WzmallIndex',
      component: BusinessPage,
      meta: {
        title: '万知商务-商家信息'
      }
    },
    {
      path: '/wzmall/businessEvaluation',
      name: 'BusinessEvaluation',
      component: BusinessEvaluation,
      meta: {
        title: '万知商务-商品信息'
      }
    },
    {
      path: '/wzmall/businsserSettleIn',
      name: 'BusinsserSettleIn',
      component: BusinesserSettle,
      meta: {
        title: '万知商务入驻'
      }
    },
    {
      path: '/wzmall/shoppingCart',
      name: 'ShoppingCart',
      component: ShoppingCart,
      meta: {
        title: '万知商务-购物车',
        requireLogin: true
      }
    },
    {
      path: '/wzmall/snapUp',
      name: 'SnapUp',
      component: SnapUp,
      meta: {
        title: '万知商务-商品抢购',
        requireLogin: true
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/business.js